import { TextField } from '@mui/material'
import { FieldDef } from '../types'

interface Props {
  field: FieldDef
  value: string
  onChange: (v: string) => void
}

export default function RichTextWidget({ field, value, onChange }: Props) {
  return (
    <TextField
      label={field.label}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      multiline
      minRows={4}
      maxRows={12}
      required={field.required}
      helperText="Plain text or basic markdown supported."
    />
  )
}
